module.exports = __webpack_public_path__ + "img/neta.374be515.png";